import React, { FC, ReactElement } from 'react'
import { Text, TextProps } from '@chakra-ui/react'
import { useColor } from '../../theme'

interface ISectionListItemFieldProps extends TextProps {
  text?: ReactElement | string
  textColor?: string
}

export const SectionListItemField: FC<ISectionListItemFieldProps> = ({
  text,
  textColor,
  ...restProps
}) => {
  const defaultColor = useColor({ nuance: 2, palette: 'text' })

  return (
    <Text
      color={textColor ?? defaultColor}
      textAlign="left"
      w="auto"
      {...restProps}>
      {text}
    </Text>
  )
}
